import React from 'react'
import styles from './UIGamePlayerInfoToggle.module.scss'
import clsx from 'clsx'
import IconArrow from '@static/images/player_info_toggle_arrow.svg'

export interface UIGamePlayerInfoToggleProps {
    isActive: boolean
    setIsActive: (isActive: boolean) => void
    children: React.ReactNode
}

export const UIGamePlayerInfoToggle = ({
    isActive,
    setIsActive,
    children,
}: UIGamePlayerInfoToggleProps) => <div className={clsx(styles.container, {
    [styles.active]: isActive,
})} onPointerUp={(e) => {
    e.preventDefault()
    setIsActive(!isActive)
}}>
    <div className={styles.content}>
        {children}
    </div>
    <img src={IconArrow} className={clsx(styles.arrow, {
        [styles.active]: isActive,
    })}/>
</div>
